//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addToCartMixin from '~/mixins/addToCart';

export default {
    mixins: [addToCartMixin],
    props: ['product'],
    data() {
        return {
            hover: false,
            configurableImage: null,
            maxStars: 5,
            labels: [],
        };
    },
    computed: {
        addToCartDisabled() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;

            return product.stock_status === 'OUT_OF_STOCK';
        },
        brand() {
            if (this.product) {
                return this.product.custom_attribute_brand;
            }

            return null;
        },
        image() {
            if (this.configurableImage != null) {
                return this.configurableImage;
            }
            const images = [...this.product.media_gallery];
            const last = images.pop();
            if (!this.hover) {
                return this.product.small_image.url;
            }

            return last ? last.url : this.product.small_image.url ? this.product.small_image.url : '';
        },
        title() {
            return this.product.name;
        },
        ratingPercentValue() {
            return this.product.rating_summary;
        },
    },
    async fetch() {
        let sku = this.product.sku
        this.labels = await this.$store.dispatch('productLabel/getProductLabels', { sku, mode: 'CATEGORY' });
    },
    methods: {
        stopPropagation(e) {
            e.stopPropagation();
        },
        setCurrentProductImage(payload) {
            this.configurableImage = payload?.product?.image?.url;
        },
        onHover() {
            this.hover = true;
        },
        onMouseOut() {
            this.hover = false;
        },
        styleStringToObject(styleString) {
            return styleString.split(';').reduce((styleObject, style) => {
                if (style.trim()) {
                    const [property, ...valueParts] = style.split(':');
                    const value = valueParts.join(':').trim(); // Rejoin in case value contains colons
                    if (property && value) {
                        const camelCaseProperty = property.trim().replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
                        styleObject[camelCaseProperty] = value;
                    }
                }
                return styleObject;
            }, {});
        },
    },
};
